const level = 17;
const Setting = {
  path: "",
  name: "",
  redirect: "/setting",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "",
      component: () => import("@/views/pages/setting"),
      meta: {
        requiresAuth: true,
        activeUrl: "/setting",
        parent: "/setting",
        lv: level,
      },
    },
  ],
  meta: { requiresAuth: true },
};
export default Setting;
